import { ColorNeutralGrey4, ColorNordicGrey5, Spacing24, Spacing8 } from 'autogen/design-tokens/tokens';
import Flex from 'components/Layout/components/Flex';
import styled from 'styled-components';
import { memo, useContext } from 'react';
import { Button } from 'components/Button';
import useClearAllSmartviews from 'components/generic/smartview/shared/hooks/useClearAllSmartviews';
import { useTranslation } from 'react-i18next';
import { ShowAll } from 'autogen/translation-keys/trans-website-shared';
import { Show } from 'autogen/translation-keys/trans-website-filter';
import useFilters from '../../../shared/hooks/useFilters';
import ApplyFiltersButton from './ApplyFiltersButton';
import ResetFiltersButton from './ResetFiltersButton';
import { FilterMenuDataContext } from '../../Filters/FilterMenuRenderer';

/* #region styles */
const StyledFlexColumn = styled(Flex.Column)`
    background-color: ${ColorNordicGrey5};
    border-top: 1px solid ${ColorNeutralGrey4};
    padding: ${Spacing24};
`;
/* #endregion */

const FilterMenuFooter = () => {
    const { hasPendingFilters } = useFilters();
    const {
        productList: { activeFilterValues }
    } = useContext(FilterMenuDataContext);
    const hasActiveFilters = !!activeFilterValues.length;
    const hasAnyFilters = hasPendingFilters || hasActiveFilters;

    if (!hasAnyFilters) return null;

    return (
        <StyledFlexColumn gap={Spacing8}>
            {hasPendingFilters && <ApplyFiltersButton />}
            {hasAnyFilters && <ResetFiltersButton />}
        </StyledFlexColumn>
    );
};

export default memo(FilterMenuFooter);

export function FilterMenuFooterSimple() {
    const { hasPendingFilters, applyPendingFilters } = useFilters();
    const { t } = useTranslation();

    const close = useClearAllSmartviews();

    const handleApplyFilters = () => {
        applyPendingFilters();
        close();
    };

    if (!hasPendingFilters) return null;

    return (
        <StyledFlexColumn gap={Spacing8}>
            {hasPendingFilters && (
                <Button size="lg" onClick={handleApplyFilters}>
                    {t(Show)}
                </Button>
            )}
        </StyledFlexColumn>
    );
}
